import { ColumnWidth } from "./types";

interface ColumnWidthInputProps {
  value: ColumnWidth;
  onChange: (value: ColumnWidth) => void;
}

const UNIT_OPTIONS: { value: ColumnWidth["unit"]; label: string }[] = [
  { value: "fr", label: "fr" },
  { value: "px", label: "px" },
  { value: "%", label: "%" },
  { value: "auto", label: "auto" },
];

export const ColumnWidthInput = ({ value, onChange }: ColumnWidthInputProps) => {
  return (
    <div className="flex items-center gap-2">
      {value.unit !== "auto" && (
        <input
          type="number"
          min={0}
          step={value.unit === "fr" ? 1 : 10}
          value={value.value}
          onChange={(e) => onChange({ ...value, value: Number(e.target.value) })}
          className="w-20 rounded-md border border-slate-300 px-2 py-1.5 text-sm dark:border-slate-600 dark:bg-slate-800 dark:text-slate-200"
        />
      )}
      <select
        value={value.unit}
        onChange={(e) => {
          const unit = e.target.value as ColumnWidth["unit"];
          onChange({
            value: unit === "auto" ? 0 : value.value || 1,
            unit,
          });
        }}
        className="rounded-md border border-slate-300 px-2 py-1.5 text-sm dark:border-slate-600 dark:bg-slate-800 dark:text-slate-200"
      >
        {UNIT_OPTIONS.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  );
};
